export default function StatCard({ value, label }) {
  return (
    <div className="p-6 bg-white rounded-xl border border-outline-variant/30 text-center shadow-sm">
      <div className="font-manrope text-h2 text-navy">{value}</div>
      <div className="font-manrope text-label-caps text-on-surface-variant mt-1">{label}</div>
    </div>
  );
}
